<template>
<div class="py-4">
  <div class="row flex-column flex-sm-row flex-md-row">
    <div class="col-12 col-sm-8 col-md-8 d-flex justify-content-end">
      <div class="targetImg" @click="createBall">
        <img :src="content.arDisplayImage" />
         <div class='target'>
           <div :class="{ 'ball_shadow': shadowOn }"></div>
         </div>
      </div>
      <div class="ml-2 btn-icon" @click="textfile = true">
        <img src="../assets/images/btn_text_file.png" alt="text file">
      </div>
    </div>

    <div class="col-12 col-sm-4 col-md-4 d-flex align-items-end justify-content-center">
      <!-- 看板小人 -->
      <div class="character d-flex justify-content-center">
        <span>{{ users.filter((u) => { return u.actions.map((e) => { return e.actionId }).indexOf(content.id) > -1 }).length }}/{{ users.length }}</span>
        <img src="../assets/images/pic_elf_03.png">
      </div>
      <!-- Btn -->
      <div class="mt-3">
        <button v-if="!announceAnswer" class="btn disabled-btn" disabled >公布解答</button>
        <button v-else class="btn btn-pink"  @click="$emit('showAnswer')">公布解答</button>
      </div>
    </div>
  </div>

  <!-- 彈跳視窗 -->
  <div class="textfile d-flex justify-content-center align-items-center" v-if="textfile">
    <div class="close" @click="textfile = false">
      <img src="../assets/images/btn_close.png">
    </div>
    <div class="textfileText">
      <p>{{ content.hintTxt }}</p>
    </div>
  </div>

  <div class="control" v-if="false">
    <select v-model="getColor">
      <option>blueBall</option>
      <option>redBall</option>
      <option>greenBall</option>
    </select>
    <a class="mx-3 btn btn-pink" href="#" @click="createBall">throw</a>
  </div>
</div>
</template>

<script>
export default {
  name: 'Mission',

  props: {
    content: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },

    users: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      textfile: false,
      getballShadow: false,
      announceAnswer: false,
      shadowOn: false,
      getColor: 'redBall'
    }
  },

  methods: {
    createBall (e) {
      let left = (Math.random() - 0.05) * 100
      let id = 'ball-' + Math.floor(left)
      let source = document.createElement('div')
      source.setAttribute('class', 'source')
      source.setAttribute('style', `left:${left}%`)
      source.setAttribute('id', id)
      source.innerHTML = `<div class="ball" style="animation: parabola-${id} 0.5s linear; -webkit-animation: parabola-${id} 0.5s linear;"><div class="img ${this.getColor}""></div></div>`
      document.body.appendChild(source)
      this.run(id)
    },

    createColorBall (color) {
      this.getColor = color + 'Ball'
      this.createBall()
    },

    run (id) {
      let vm = this
      let ball = document.getElementById(id)
      let target = document.querySelector('.target')
      let sourceOffset = vm.getOffsetRect(ball)
      let targetOffset = vm.getOffsetRect(target)
      let dx = targetOffset.left - sourceOffset.left
      let dy = targetOffset.top - sourceOffset.top
      let peak = dy === 0 ? 0 : (Math.abs(dy) + 100) / Math.abs(dy)

      let x1 = 0
      let x2 = dx
      let x3 = dx * (dy === 0 ? (dx / 2) : 1 / (1 + Math.sqrt(peak - 1)))
      let y1 = 0
      let y2 = dy
      let y3 = dy - 100

      let x12 = Math.pow(x1, 2)
      let x22 = Math.pow(x2, 2)
      let x32 = Math.pow(x3, 2)

      let D = vm.determinant([
        [x12, x1, 1],
        [x22, x2, 1],
        [x32, x3, 1]
      ])

      let Da = vm.determinant([
        [y1, x1, 1],
        [y2, x2, 1],
        [y3, x3, 1]
      ])

      let Db = vm.determinant([
        [x12, y1, 1],
        [x22, y2, 1],
        [x32, y3, 1]
      ])

      let Dc = vm.determinant([
        [x12, x1, y1],
        [x22, x2, y2],
        [x32, x3, y3]
      ])

      let a = Da / D
      let b = Db / D
      let c = Dc / D

      let f = vm.polynomial(a, b, c)
      let df = vm.derivative(a, b)

      let scale = `@keyframes img-scale {\
        0% { transform: scale(1); opacity: 1; }\
        99% { transform: scale(0.2); opacity: 1; }\
        100% { transform: scale(0.2); opacity: 0; }\
      }`

      let parabola = scale + `@keyframes parabola-${id} {`

      for (let i = 0; i <= 100; i += 5) {
        let x = dx * i / 100
        let angle = i === 0 ? 0 : ((dx > 0 ? 1 : -1) * 90 + (Math.atan(df(x)) * 180 / Math.PI))
        let rotate = dx === 0 ? 'rotateX' : 'rotateZ'
        parabola += i + '% { transform: translate(' + x + 'px, ' + f(x) + 'px) ' + rotate + '(' + angle + 'deg); }'
      }

      parabola += '}'

      let style = document.createElement('style')
      style.setAttribute('id', 'mystyle')
      let content = document.createTextNode(parabola)
      style.appendChild(content)

      document.body.appendChild(style)
      setTimeout(() => {
        let element = document.getElementById('mystyle')
        let source = document.querySelector('.source')
        source.parentNode.removeChild(source)
        element.parentNode.removeChild(element)
      }, 700)

      let showEnd = function () {
        setTimeout(function () {
          vm.shadowOn = true
          vm.$emit('changeBg', 'true')
        }, 500)
        setTimeout(function () {
          vm.shadowOn = false
        }, 700)
        setTimeout(function () {
          vm.announceAnswer = true
        }, 1000)
      }
      document.addEventListener('click', this.debounce(showEnd(), 5000), false)
    },

    getOffsetRect (elem) {
      let ball = elem.getBoundingClientRect()

      let body = document.body
      let docElem = document.documentElement

      let scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
      let scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

      let clientTop = docElem.clientTop || body.clientTop || 0
      let clientLeft = docElem.clientLeft || body.clientLeft || 0

      let top = ball.top + scrollTop - clientTop
      let left = ball.left + scrollLeft - clientLeft

      return { top: Math.round(top), left: Math.round(left) }
    },

    determinant (a) {
      if (a.length === 2) {
        return (a[0][0] * a[1][1]) - (a[1][0] * a[0][1])
      }

      if (a.length === 3) {
        return (a[0][0] * this.determinant([
          [a[1][1], a[1][2]],
          [a[2][1], a[2][2]]
        ])) - (a[0][1] * this.determinant([
          [a[1][0], a[1][2]],
          [a[2][0], a[2][2]]
        ])) + (a[0][2] * this.determinant([
          [a[1][0], a[1][1]],
          [a[2][0], a[2][1]]
        ]))
      }
    },

    polynomial (a, b, c) {
      return function (x) {
        return (a * Math.pow(x, 2)) + (b * x) + c
      }
    },

    derivative (a, b) {
      return function (x) {
        return 2 * a * x + b
      }
    },

    debounce (fn, delay) {
      let timer

      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {}, delay)
      }
    }
  }
}
</script>

<style lang="scss">
  .targetImg {
    position: relative;
    max-height:500px;
    width: 500px;
    border: 8px solid gray;
    .target {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 150px;
      height: 150px;
      transform: translate(-50%, -50%);
    }
    img {
      height: 100%;
      width: 100%;
    }
  }

  .btn-icon {
    cursor: pointer;
    height: 50px;
    width: 50px;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  .btn {
    padding: 10px 30px;
    border-radius: 5px;
    font-weight: bold;
  }
  .disabled-btn {
    background-color: #8a8a8a;
  }
  // 看板小人
  .character {
    position: absolute;
    bottom: 15%;
    height: 180px;
    width: 180px;
    span {
      position: absolute;
      top: 34%;
      left: 40%;
      transform: translateX(-50%);
      color: white;
      font-weight: 700;
    }
    img {
      object-fit: contain;
    }
  }
  @media screen and (max-width: 769px) {
    .character {
      right: 15%;
      bottom: 15%;
      height: 150px;
      width: 150px;
    }
  }
  @media screen and (max-width: 568px) {
    .character {
      right: 0%;
      bottom: 5%;
      height: 130px;
      width: 130px;
    }
  }
  // 彈跳視窗
  .textfile {
    position: fixed;
    top: 0;
    left: 0;
    background: black;
    opacity: 0.8;
    width: 100%;
    height: 100%;
    .close {
      cursor: pointer;
      position: absolute;
      right: 8%;
      top: 20%;
      opacity: 1;
      width: 30px;
      height: 30px;
      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
    .textfileText {
      max-width: 450px;
      max-height: 300px;
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translateX(-50%);
      p {
        color: white;
        font-size: 1.4em;
      }
    }
  }

  @media screen and (max-width: 769px) {
    .textfile {
      position: fixed;
      top: 0;
      left: 0;
      background: black;
      opacity: 0.8;
      width: 100%;
      height: 100%;
        .close {
          right: 8%;
        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }
    }
  }
  @media screen and (max-width: 568px) {
    .textfile {
      position: fixed;
      top: 0;
      left: 0;
      background: black;
      opacity: 0.8;
      width: 100%;
      height: 100%;
      .close {
        right: 8%;
        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .ball_shadow {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    height: 00%;
    width: 0%;
    border-radius: 50%;
    background: white;
    box-shadow: 0 0 50px 50px  white;
  }
  .img {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 150px;
    -webkit-animation: img-scale 0.5s linear;
    -webkit-animation-fill-mode: forwards;
    animation: img-scale 0.5s linear;
    animation-fill-mode: forwards;
    background-size:cover;
  }

  .control {
    position: absolute;
    top: 20%;
    left: 2%;
  }

  // ball img
  .blueBall {
    background-image:url('../assets/images/pic_ball_blue.png');
  }
  .redBall {
    background-image:url('../assets/images/pic_ball_red.png');
  }
  .greenBall {
    background-image:url('../assets/images/pic_ball_green.png');
  }

  .source {
    position: absolute;
    top: 490px;
    left: 10px;
    width: 150px;
    height: 150px;
  }

  .ball {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 150px;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
  }
</style>
